// ============================================================
// INGREDIABLE — Supabase Client Configuration
// ============================================================
// Copy .env.example to .env and add your project URL and anon key
// from Supabase Dashboard > Settings > API. When unset, app runs in local-only mode.
// ============================================================

import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { createAuthStorage } from "./auth-storage";

const rawUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const rawKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
const supabaseUrl = typeof rawUrl === "string" ? rawUrl.trim() : undefined;
const supabaseAnonKey = typeof rawKey === "string" ? rawKey.trim() : undefined;

export const hasSupabase = !!(supabaseUrl && supabaseAnonKey);

// Use IndexedDB-backed storage so sessions persist when the app is opened
// from the iPhone home screen (standalone PWA), where localStorage is often cleared.
const authStorage = createAuthStorage();

export const supabase: SupabaseClient | null = hasSupabase
  ? createClient(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storage: authStorage,
      },
      realtime: { params: { eventsPerSecond: 10 } },
    })
  : null;

export default supabase;
